// eslint-disable-next-line no-restricted-imports -- decoration only: a missing or failing status must not replace the phase content
import { useQuery } from '@tanstack/react-query';
import { availabilityImportEndpoints, isNotFoundError } from '@ooh/contracts';
import { useApiClient } from '../../plugs/api-client';
import type { AvailabilityImportPhase } from '../components/availability-import-wizard';
import { apiQueryOptions } from '../../data/use-api-suspense-query';

/**
 * A later phase needs a job in the address. The result phase is the only one that can be opened
 * by address alone, so only there the server is asked whether the job exists (sharing the status
 * cache entry with the phase itself); the review phases without an upload return to upload instead.
 */
export function useJobNotFound(phase: AvailabilityImportPhase, jobId: number | null): boolean {
  const api = useApiClient();
  const id = phase === 'result' ? (jobId ?? 0) : 0;
  const { error } = useQuery({
    ...apiQueryOptions(api, availabilityImportEndpoints.status, { id }),
    enabled: id > 0,
  });
  const lookupNotFound = error != null && isNotFoundError(error);
  return phase !== 'upload' && (jobId === null || lookupNotFound);
}
